import { config } from '@/lib/config';
import { cn } from '@/lib/utils';

export function BrandMark({ className }) {
  return (
    <span
      data-brand-mark
      className={cn('relative inline-flex shrink-0 overflow-hidden', className)}
      aria-hidden="true"
    >
      <img
        src="/brand/amortal-square-light.svg"
        alt=""
        className="size-full dark:hidden"
      />
      <img
        src="/brand/amortal-square-dark.svg"
        alt=""
        className="hidden size-full dark:block"
      />
    </span>
  );
}

export default function BrandLockup({
  compact = false,
  className,
  markClassName,
}) {
  return (
    <span
      data-brand-lockup
      className={cn('inline-flex items-center gap-2', className)}
      aria-label={compact ? config.app.name : undefined}
    >
      <BrandMark className={cn('size-7', markClassName)} />
      {!compact && (
        <span className="font-heading text-lg font-semibold tracking-tight">
          {config.app.name}
        </span>
      )}
    </span>
  );
}
